import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SharedReportOutputModule } from '@ndt/report-output/shared/shared-report-output.module';
import { SharedReportsModule } from '@ndt/reports/shared/shared-reports.module';
import { DialogModule } from 'src/app/common-components/dialog/dialog.module';
import { TileLayoutConfigurationsModule } from 'src/app/pages/dashboard/tile-layout-configurations/tile-layout-configurations.module';
import { TileParametersComponent } from './tile-parameters.component';

@NgModule({
   declarations: [TileParametersComponent],
   imports: [
      CommonModule,
      MatButtonModule,
      MatIconModule,
      ReactiveFormsModule,
      DialogModule,
      SharedReportsModule,
      SharedReportOutputModule,
      TileLayoutConfigurationsModule,
      MatDialogModule,
   ],
   exports: [TileParametersComponent],
})
export class TileParametersModule {}
